<template>
    <div class="col-sm-12 nopads list-container pb-3">
        <Transition name="fade">
            <!-- Main table element -->
            <div
                v-if="results.length > 0"
                class="col-sm-12 list-content result-table"
            >
                <vue3-datatable
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :height="results.length > 5 ? '65vh' : '100%'"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                >
                    <template #duration="row">
                        <span>{{ row.value.duration ? getWorkTime(Math.round(row.value.duration / 60)) : "-" }}</span>
                    </template>
                    <template #vehicle_allocation_time="row">
                        <span>{{ row.value.vehicle_allocation_time ? getWorkTime(row.value.vehicle_allocation_time) : "-" }}</span>
                    </template>
                    <template #allocation_percent="row">
                        <span>{{ row.value.allocation_percent ? row.value.allocation_percent.toFixed(2) : '-' }}</span>
                    </template>
                </vue3-datatable>
            </div>
        </Transition>
    </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import {vehicleHelper} from '../../mixins/VehicleMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'VehicleAllocationList',
    components: {Vue3Datatable},
    mixins: [timeUtils, vehicleHelper],
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        },
        params: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            fields: [
                { field: "vehicle", label: this.$t('trip_list.vehicle'), sortable: true, headerClass: 'routa-table-header'},
                { field: "duration", title: this.$t('trip_list.duration') + ' ' + '(h)', sort: true, headerClass: 'routa-table-header', type: "number"},
                { field: "vehicle_allocation_time", title: this.$t('trip_list.vehicle_allocation') + ' ' + '(h)', sort: true, headerClass: 'routa-table-header', type: "number"},
                { field: "allocation_percent", title: this.$t('trip_list.allocation_percent') + ' ' + '(%)', sort: true, headerClass: 'routa-table-header', type: "float"}
            ],
            results: []
        }
    },
    watch: {
        items: function () {
            this.initTableItems()
        }
    },
    methods: {
        initTableItems: function () {
            this.results = []
            this.items.forEach(function(item) {
                this.results.push({
                    vehicle_id: item.vehicle_id,
                    vehicle: item.vehicle,
                    allocation_percent: parseFloat(item.allocation_percent),
                    duration: item.duration,
                    vehicle_allocation_time: item.vehicle_allocation_time
                })
            }, this)
        },
        emitDetails: function (result) {
            // Find defect item from original items and emit request to edit
            let p = this.items.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        },
    }
}
</script>

<style scoped>

</style>
